import styles from "./Outerspace.module.css";
const Outerspace: React.FC = () => <div className={styles.outerspace} />;
export default Outerspace;
